import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PageScrollConfig, PageScrollService, PageScrollInstance} from 'ng2-page-scroll';
import {DOCUMENT} from '@angular/common';
import {Subject} from 'rxjs/internal/Subject';
import {Subscription} from 'rxjs';
import {environment} from '../../environments/environment';
import {toSignal} from '@angular/core/rxjs-interop';

const MOCK_REPORTS: any[] = [
  { post_id: 1, post_name: '1st Time Admit Students', post_content: 'Admit term, student type, and college breakdown for first-time students.', report_type: ['Banner'], report_categories: ['Admissions', 'Enrollment'], report_likes: 14, report_viewes: 312, report_viewes_user: 3, report_favorited: false, report_highlighted: null, external_url: '#', date_created: '2023-09-01', date_modified: '2024-10-15' },
  { post_id: 2, post_name: 'Accounting Services Grant & Plant', post_content: 'Detailed transaction and summary for grant allocation and spending.', report_type: ['PowerBI'], report_categories: ['Finance', 'Finance'], report_likes: 8, report_viewes: 198, report_viewes_user: 1, report_favorited: false, report_highlighted: null, external_url: '#', date_created: '2023-11-05', date_modified: '2024-09-20' },
  { post_id: 3, post_name: 'Active Courses', post_content: 'Hybrid and online course offerings at catalog level with schedule types.', report_type: ['Banner'], report_categories: ['Academic Affairs', 'Academics'], report_likes: 22, report_viewes: 541, report_viewes_user: 5, report_favorited: true, report_highlighted: null, external_url: '#', date_created: '2023-08-12', date_modified: '2024-11-01' },
  { post_id: 4, post_name: '2U Reconciliation – Law School', post_content: 'Enrollment, scholarship, and fee details with 2U for delta reconciliation.', report_type: ['Banner'], report_categories: ['Finance', 'Finance'], report_likes: 5, report_viewes: 87, report_viewes_user: 0, report_favorited: false, report_highlighted: null, external_url: '#', date_created: '2024-01-10', date_modified: '2024-08-30' },
  { post_id: 5, post_name: 'Active Employees', post_content: 'List of all active employees from HRIS.', report_type: ['Workday'], report_categories: ['Human Resources', 'HR'], report_likes: 11, report_viewes: 276, report_viewes_user: 2, report_favorited: false, report_highlighted: null, external_url: '#', date_created: '2023-07-20', date_modified: '2024-10-28' },
  { post_id: 6, post_name: 'Financial Aid Awards Summary', post_content: 'Award totals by aid year, fund type, and enrollment status.', report_type: ['Banner'], report_categories: ['Financial Aid', 'Financial Aid'], report_likes: 19, report_viewes: 430, report_viewes_user: 4, report_favorited: true, report_highlighted: null, external_url: '#', date_created: '2023-10-03', date_modified: '2024-11-05' },
  { post_id: 7, post_name: 'Graduate Enrollment by Program', post_content: 'Headcount and FTE for graduate programs by school, term, and student level.', report_type: ['PowerBI'], report_categories: ['Graduate Schools', 'Enrollment Services'], report_likes: 16, report_viewes: 388, report_viewes_user: 3, report_favorited: false, report_highlighted: null, external_url: '#', date_created: '2023-09-14', date_modified: '2024-10-10' },
  { post_id: 8, post_name: 'Pell Grant Eligibility Dashboard', post_content: 'Students flagged as Pell-eligible broken down by school, program, and aid year.', report_type: ['Banner'], report_categories: ['Financial Aid', 'Institutional Research'], report_likes: 9, report_viewes: 214, report_viewes_user: 1, report_favorited: false, report_highlighted: null, external_url: '#', date_created: '2024-02-18', date_modified: '2024-09-05' },
  { post_id: 9, post_name: 'Payroll Summary by Department', post_content: 'Total compensation, benefits, and FTE by cost center and employee class.', report_type: ['Workday'], report_categories: ['Finance', 'Human Resources'], report_likes: 7, report_viewes: 162, report_viewes_user: 2, report_favorited: false, report_highlighted: null, external_url: '#', date_created: '2024-03-01', date_modified: '2024-11-08' },
  { post_id: 10, post_name: 'Retention & Persistence Report', post_content: 'First-time full-time cohort retention from fall to fall, with breakdown by school and GPA band.', report_type: ['PowerBI'], report_categories: ['Institutional Research', 'Student Success'], report_likes: 28, report_viewes: 612, report_viewes_user: 6, report_favorited: true, report_highlighted: 'highlighted', external_url: '#', date_created: '2023-06-15', date_modified: '2024-10-22' },
  { post_id: 11, post_name: 'Course Section Fill Rates', post_content: 'Capacity vs. actual enrollment per section, sorted by undersubscribed courses.', report_type: ['Tableau'], report_categories: ['Academic Affairs', 'Enrollment Services'], report_likes: 13, report_viewes: 295, report_viewes_user: 2, report_favorited: false, report_highlighted: null, external_url: '#', date_created: '2023-11-22', date_modified: '2024-09-15' },
  { post_id: 12, post_name: 'Student Success Alerts', post_content: 'Early-alert flags by advisor, risk level, and intervention status for current term.', report_type: ['Banner'], report_categories: ['Student Success', 'Academic Affairs'], report_likes: 18, report_viewes: 403, report_viewes_user: 5, report_favorited: false, report_highlighted: null, external_url: '#', date_created: '2024-01-30', date_modified: '2024-11-10' },
];

const MOCK_CATEGORIES: any[] = [
  { category_name: 'Academic Affairs', count: 12, child: [] },
  { category_name: 'Admissions', count: 5, child: [] },
  { category_name: 'Analytics – Public', count: 10, child: [] },
  { category_name: 'Enrollment Services', count: 18, child: [] },
  { category_name: 'Finance', count: 27, child: [] },
  { category_name: 'Financial Aid', count: 8, child: [] },
  { category_name: 'Graduate Schools', count: 7, child: [] },
  { category_name: 'Human Resources', count: 18, child: [] },
  { category_name: 'Institutional Research', count: 4, child: [] },
  { category_name: 'Student Success', count: 13, child: [] },
];

@Injectable({
  providedIn: 'root'
})
export class GetSetDataService {

  public EmitterSearch: Subject<string> = new Subject();
  public EmitterLoader: Subject<boolean> = new Subject();
  public EmitterReportLenght: Subject<boolean> = new Subject();
  public EmitterUserniceName: Subject<string> = new Subject();
  public EmitterDataFetched: Subject<boolean> = new Subject();

  private subscriptionData: Subscription = new Subscription();
  public globalSearchQuery = '';

  constructor(private http: HttpClient,
              private pageScrollService: PageScrollService,
              @Inject(DOCUMENT) private document: any) {
  }

  public emitSearchQuery(searchQuery: string) {
    this.globalSearchQuery = searchQuery;
    this.EmitterSearch.next(searchQuery);
  }

  public getCategories() {
    return new Promise((resolve, reject) => {
      this.toggleLoader(true);

      this.http.get(environment.CATEGORY_API).subscribe((data) => {
        this.toggleLoader(false);
        resolve(data);
      }, (error) => {
        this.toggleLoader(false);
        resolve(MOCK_CATEGORIES);
      });
    });
  }

  public getPostsByCategory(categoryName: string) {

    if (this.subscriptionData) {
      this.subscriptionData.unsubscribe();
    }

    return new Promise((resolve, reject) => {
      this.toggleLoader(true);

      this.subscriptionData = this.http.get(environment.REPORTS_API + categoryName).subscribe((data) => {
        this.toggleLoader(false);
        resolve(data);
      }, (error) => {
        this.toggleLoader(false);
        const filtered = MOCK_REPORTS.filter(r =>
          r.report_categories?.some((c: string) => c.toLowerCase() === categoryName.toLowerCase())
        );
        resolve({ results: filtered.length ? filtered : MOCK_REPORTS, top_content: null, charts: [] });
      });
    });
  }

  public getAllPosts() {

    if (this.subscriptionData) {
      this.subscriptionData.unsubscribe();
    }

    return new Promise((resolve, reject) => {
      this.toggleLoader(true);

      this.subscriptionData = this.http.get(environment.POSTS_ALL_API).subscribe((data: any) => {
        this.toggleLoader(false);
        this.EmitterReportLenght.next(data.length);
        resolve(data);
      }, (error) => {
        this.toggleLoader(false);
        this.EmitterReportLenght.next(true);
        resolve(MOCK_REPORTS);
      });
    });
  }

  public getBlogPosts() {
    return new Promise((resolve, reject) => {
      this.toggleLoader(true);

      this.http.get(environment.BLOG_POSTS_API).subscribe((data) => {
        this.toggleLoader(false);
        resolve(data);
      }, (error) => {
        this.toggleLoader(false);
        reject(error);
      });
    });
  }

  public getFavoriteReports(): any {
    return new Promise((resolve, reject) => {
      this.toggleLoader(true);

      this.http.get(environment.FAVORITE_REPORTS).subscribe((data: any) => {
        this.toggleLoader(false);

        // We emit data if there's something.

        if (data) {
          this.EmitterUserniceName.next(data.username[0]);
        }

        resolve(data);
      }, (error) => {
        this.toggleLoader(false);
        reject(error);
      });
    });
  }

  public setFavoriteReport(reportID: string) {
    return new Promise((resolve, reject) => {

      this.http.get(environment.SET_FAVORITE_REPORTS + reportID).subscribe((data) => {
        resolve(true);
      }, (error) => {
        this.toggleLoader(false);
        reject(error);
      });
    });
  }

  public removeFavoriteReport(reportID: string) {
    return new Promise((resolve, reject) => {

      this.http.get(environment.REMOVE_FAVORITE_REPORTS + reportID).subscribe((data) => {
        resolve(true);
      }, (error) => {
        this.toggleLoader(false);
        reject(error);
      });
    });
  }

  public logoutUser() {
    return new Promise((resolve, reject) => {
      this.http.get(environment.LOGOUT_USER).subscribe((data) => {
        location.reload();
        resolve(true);
      }, (error) => {
        this.toggleLoader(false);
        location.reload();
        resolve(true);
      });
    });
  }

  public getPostsCount() {
    return new Promise((resolve, reject) => {
      this.http.get(environment.POST_COUNT).subscribe((data: any) => {
        resolve(data[0].counter);
      }, (error) => {
        resolve(MOCK_REPORTS.length);
      });
    });
  }

  public getSingleBlogPosts(postID: string) {

    if (this.subscriptionData) {
      this.subscriptionData.unsubscribe();
    }

    return new Promise((resolve, reject) => {
      this.toggleLoader(true);

      this.subscriptionData = this.http.get(environment.BLOG_SINGLE_POSTS_API + postID).subscribe((data: any) => {
        this.toggleLoader(false);
        resolve(data[0]);
      }, (error) => {
        this.toggleLoader(false);
        reject(error);
      });
    });
  }

  /**
   * Updates report counter by user.
   * @param postID
   */
  public updateReportCountersByUser(postID: number) {
    return new Promise((resolve, reject) => {
      this.http.get(environment.UPDATE_REPORT_VIEW_BY_USER + postID).subscribe((result) => {
        resolve(true);
      }, (error) => {
        reject('Error updating report counter by user.');
      });
    });
  }

  /**
   * Updates report counter by all.
   * @param postID
   */
  public updateReportCountersByAll(postID: number) {
    return new Promise((resolve, reject) => {
      this.http.get(environment.UPDATE_REPORT_VIEW_COUNTER + postID).subscribe((result) => {
        resolve(true);
      }, (error) => {
        reject('Error updating report counter by all.');
      });
    });
  }

  /**
   * Updates report likes.
   * @param postID
   */
  public updateReportLikes(postID: number) {
    return new Promise((resolve, reject) => {
      this.http.get(environment.LIKE_REPORT + postID).subscribe((result) => {
        resolve(true);
      }, (error) => {
        reject('Error updating report like.');
      });
    });
  }

  public toggleLoader(type: boolean) {
    this.EmitterLoader.next(type);
  }

  public scrollToElement(targetElement: any) {
    const pageScrollInstance: PageScrollInstance = PageScrollInstance.newInstance({
      document: this.document,
      scrollTarget: targetElement,
      pageScrollOffset: 100
    });

    this.pageScrollService.start(pageScrollInstance);
  }

  public scrollToTop() {
    const pageScrollInstance: PageScrollInstance = PageScrollInstance.newInstance({
      document: this.document,
      scrollTarget: document.getElementsByTagName('body')[0]
    });

    this.pageScrollService.start(pageScrollInstance);
  }

  /**
   * Updates report counter by user.
   */
  public getFaqContent() {
    return new Promise((resolve, reject) => {
      this.http.get(environment.FAQ_CONTENT).subscribe((result) => {
        resolve(result);
      }, (error) => {
        reject('Error getting FAQ content from API.');
      });
    });
  }
}
